export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11531.5d307a38.jpg";